module.exports = __webpack_public_path__ + "static/media/oop.6c1b20cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/oop.png
// module id = 65
// module chunks = 0